var map = {
	"./insta.svg": 602,
	"./insta1.svg": 603,
	"./linkedin.svg": 604,
	"./linkedin0.svg": 605,
	"./twitter.svg": 606,
	"./twitter3.svg": 607,
	"./youtube.svg": 608,
	"./youtube2.svg": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;